$(document).ready(function() {
  /*===========================================================================================*/
  /*                          INITIALIZE GLOBAL VARIABLES                                      */
  /*===========================================================================================*/
  var default_page_no = 1;
  var itemsperpage = 1;
  var integrationURL = 'https://www.uconnectsecure.co.za/acdc/'; 
  var GETintegrationURL = 'https://www.uconnectsecure.co.za/getItemDiscount/';
  var product_page_url;
  var total_page_count;
  var html = "";
  var html_string_page = {};
  var totalPageCount;
  var alreadyFiltering = false;
  var dbname = getCookie('storeDB');
  var specialTag = false;
  var clearTag = false;
  var getSKUurl = window.location.href;
  var productSKU = getSKUurl.split("?")[1];

  /*===========================================================================================*/
  /* CHECK IF CUSTOMER IS LOGGED IN OR NOT                                                     */
  /*===========================================================================================*/

  if ($(".customerACC").text() == ""){
    var customer = "WEBSITE";
  } else {
    var customer = $(".customerACC").text();
  }

  /*===========================================================================================*/
  /*                                 MONEY FORMATING                                           */
  /*===========================================================================================*/
  function formatMoney(number, places, symbol, thousand, decimal) {

    places = !isNaN(places = Math.abs(places)) ? places : 2;

    symbol = symbol != undefined ? symbol : "R ";

    thousand = thousand || " ";
    decimal = decimal || ".";
    var   negative = number < 0 ? "-" : "",
        i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
  } 

  /*===========================================================================================*/
  /*                                 GET COOKIE                                                */
  /*===========================================================================================*/
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');

    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length,c.length);
      }
    }
    return "";
  }

  /*===========================================================================================*/
  /*                                    REMOVE URL SLASHES                                     */
  /*===========================================================================================*/
  // REMOVE ALL SPACES & SPECIAL CHARS FROM URL AND REPLACES WITH - 
  function convertURLslash(slash_url) {
    slash_url = slash_url.replace('/','_');
    var no_slash_URL = slash_url.replace("/", "_");
    return no_slash_URL;
  }

  /*===========================================================================================*/
  /*                                    REMOVE URL SPACES                                      */
  /*===========================================================================================*/
  // REMOVE ALL SPACES & SPECIAL CHARS FROM URL AND REPLACES WITH - 
  function removeURLspaces(space_url) {
    space_url = space_url.replace('- ','');
    space_url = space_url.replace(/^[-]/, "");
    space_url = space_url.replace('  ','-');
    space_url = space_url.replace(' - ','-');
    space_url = space_url.replace(' - ','-');
    space_url = space_url.replace(' - ','-');
    space_url = space_url.replace(' - ','-');
    space_url = space_url.replace(" / ","-");
    space_url = space_url.replace(" / ","-");
    space_url = space_url.replace(" / ","-");
    space_url = space_url.replace(" / ","-");
    space_url = space_url.replace('%','');
    space_url = space_url.replace(' @ ','-');
    space_url = space_url.replace('..','-');
    space_url = space_url.replace('. ','-');
    space_url = space_url.replace('"+" ','');
    space_url = space_url.replace(')+(','-');
    space_url = space_url.replace('(','');
    space_url = space_url.replace(')','');    
    space_url = space_url.replace('+ ',''); 
    space_url = space_url.replace(' +','-'); 
    space_url = space_url.replace(' +','-'); 
    space_url = space_url.replace(' +','-'); 
    space_url = space_url.replace(' "','');
    space_url = space_url.replace('"','');
    space_url = space_url.replace("'",'');
    space_url = space_url.replace(" /",'-');

    var no_space_URL = space_url.replace(/[^A-Z0-9]/ig, "-");
    return no_space_URL;
  }

  /*===========================================================================================*/
  /*                                       PRODUCT INFO TABS                                   */
  /*===========================================================================================*/
  function productTabs() {
    if ($('#infBlock1').find('.row1prodDesc').text().length > 0) {
      $("#infBlock1").fadeIn(1000);
      $("#tab1").css("color", "#0070ba");
      $("#tab2").css("color", "#999");
      $("#tab3").css("color", "#999");
    } else if ($('#infBlock2').find('.row1prodDesc').text().length > 0) {
      $("#infBlock2").fadeIn(1000);
      $("#tab1").css("color", "#999");
      $("#tab2").css("color", "#0070ba");
      $("#tab3").css("color", "#999");
    } else if ($('#infBlock3').find('.row1prodDesc').find('.leftprodSpecPull').text().length > 0) {
      $("#infBlock3").fadeIn(1000);
      $("#tab1").css("color", "#999");
      $("#tab2").css("color", "#999");
      $("#tab3").css("color", "#0070ba");
    } else {
      $(".tabHolders").css("display", "none");
    }

    $("#Tab1").click(function(){
      if ($('#infBlock1').find('.row1prodDesc').length > 0) {
        $("#infBlock1").fadeIn(1000);
        $("#infBlock2").fadeOut(200);
        $("#infBlock3").fadeOut(200);
        $("#tab1").css("color", "#0070ba");
        $("#tab2").css("color", "#999");
        $("#tab3").css("color", "#999");
      }
    });

    $("#Tab2").click(function(){
      if ($('#infBlock2').find('.row1prodDesc').length > 0) {
        $("#infBlock2").fadeIn(1000);
        $("#infBlock1").fadeOut(200);
        $("#infBlock3").fadeOut(200);
        $("#tab1").css("color", "#999");
        $("#tab2").css("color", "#0070ba");
        $("#tab3").css("color", "#999");
      }
    });

    $("#Tab3").click(function(){
      if ($('#infBlock3').find('.row1prodDesc').length > 0) {
        $("#infBlock3").fadeIn(1000);
        $("#infBlock1").fadeOut(200);
        $("#infBlock2").fadeOut(200);
        $("#tab1").css("color", "#999");
        $("#tab2").css("color", "#999");
        $("#tab3").css("color", "#0070ba");
      }
    });

  }

  /*===========================================================================================*/
  /*                                       PRODUCT FILTER                                      */
  /*===========================================================================================*/
  //THIS FUNCTION GENERATES A BLANK FILTER OBJECT. IF SEND TO SERVER IT WILL RETURN ALL PRODUCTS
  //SINCE NOTHING HAS BEEN SPECIFIED
  function initialiseFilter() {
    return  {  
      "brand" :[],
      "category" : [],
      "price" : [],
      "special" : [],
      "clearance" : [],
      "search" : productSKU
    };
  }
  var filter = initialiseFilter();


  /*===========================================================================================*/
  /* ADD TO FAVOURITES FUNCTIONS                                                               */
  /*===========================================================================================*/  

  function favGetCookie() {
    var key,val,res;
    //get all cookie
    var oldCookie = document.cookie.split(';');
    for (var i = 0; i < oldCookie.length; i++) {
      key = oldCookie[i].substr(0,oldCookie[i].indexOf("="));
      val = oldCookie[i].substr(oldCookie[i].indexOf("=")+1);
      key = key.replace(/^\s+|\s+$/g,"");
      //find "user_cookie"
      if(key == "favItems") {
        res = val;
      }
    }
    if (res == undefined) {
      return null;
    } else {
      res = JSON.parse(res);
      return res.user;
    }
  } 

  function addToFAV() {
    var tempInit = favGetCookie();
    var str = JSON.stringify(tempInit);
    $('.addToFav').click(function() {
      $(this).text("Added To Favourites");
      var theSKUFavInit = $('.product-info-code').text();
      var arr = new Array();
      var obj = new Object();

      //add new cookie data
      obj.variant = theSKUFavInit;
      arr.push(obj);

      //get old cookie data
      var temp = favGetCookie();
      var str = JSON.stringify(temp);
      if (temp != null) {
        //concat new and old cookie data
        for (var i = 0; i < temp.length; i++) { 
          var ob = new Object();
          ob.variant = temp[i].variant;
          arr.push(ob);
        }
      }
      var objWarp = new Object();
      objWarp.user = arr;
      var val = JSON.stringify(objWarp);
      document.cookie = "favItems=" + val + '; expires=Fri, 31 Dec 9999 23:59:59 GMT"; path=/';
    });
    var theSKUFav = $('.product-info-code').text();
    if (str.indexOf(theSKUFav) > 0) {    
      $('.addToFav').text("In Favourites");
      $('.addToFav').unbind('click');
    } else {
      $('.addToFav').text("Add To Favourites");
      $('.addToFav').bind('click');
    }
  }
  /*===========================================================================================*/
  /* PULL INDIVIDUAL PRODUCT INFO DIRECTLY FROM ACDC-DYNAMICS SERVER                           */
  /*===========================================================================================*/  
  var productURLsku = window.location.href;
  var productSKU = productURLsku.substr(productURLsku.indexOf("?") + 1); 

  $.get(GETintegrationURL + customer + '/' + convertURLslash(productSKU)).done(function(data) {
    if (data.options.length > 0) {
      for(var T = 0; T < data.options.length; T++) {
        if(data.options[T].OPTFIELD === "CERTLINK") {
          if (data.options[T].VALUE === "http://storage-download.googleapis.com") {
           /*
            $('#product_container').find('#linkProdCert').removeAttr('href');
            $('#product_container').find('#linkProdCert').removeAttr('target');
            $('#product_container').find('#linkProdCert').addClass('noCert');
            
            $('#product_container').find('.CertBlock').click(function() {
              $('.popOverlay').show();
              $('.popText').show();
              $('#techSpec').hide();
              var sku = $('.product-info-code').text();
              $('#IndiProdID').attr('value',sku);
            });
            */
          } else {
            var CertLink = data.options[T].VALUE;
            
          }                  
        } 
        
        if(data.options[T].OPTFIELD === "SPECLINK") {
          if (data.options[T].VALUE === "http://storage-download.googleapis.com") {
            /*
            $('#product_container').find('#linkTechSpec').removeAttr('href');
            $('#product_container').find('#linkTechSpec').removeAttr('target');
            $('#product_container').find('#linkTechSpec').addClass('noCert');

            $('#product_container').find('.TechBlock').click(function() {
              $('.popOverlay').show();
              $('.popText').show();
              $('#certSpec').hide();
              var sku = $('.product-info-code').text();
              $('#IndiProdID').attr('value',sku);
            });
           */
          } else {
            var SpecLink = data.options[T].VALUE;
            $('#linkTechSpec').attr('target','_blank');
          }                  
        }

        if( data.options[T].OPTFIELD === "PICTURE") {
          var PicLink = data.options[T].VALUE;
        } 

        if( data.options[T].OPTFIELD === "CATPAGE") {
          var catPage = data.options[T].VALUE;
        } 
      }
    }

    var saving = data.price[0].Price * data.discount[0].Discount/100;
    var nettPrice = data.price[0].Price - saving;
    var listPrice = data.price[0].Price;
    var unitType = "";
    var category = data.price[0].Category;
    var brand = ""
    //CHECK TO IF ANY SALES PRICES ARE RETURNED
    if(data.salesPrice.length !== 0) {
      specialTag = true;
      var nettPriceSaving = data.salesPrice[0].Price;
      var savingSpecial = data.price[0].Price - data.salesPrice[0].Price;

      //IF SPECIAL PRICE IS BIGGER THAN DISCOUNTED, DISPLAY SPECIAL PRICE
      if (savingSpecial > saving) {
        saving = formatMoney(savingSpecial, 2, 'R ', ' ', '.'); 
        nettPrice = formatMoney(nettPriceSaving, 2, 'R ', ' ', '.');
        listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');
      } else { 
        nettPrice = formatMoney(nettPrice, 2, 'R ', ' ', '.');  
        saving = formatMoney(saving, 2, 'R ', ' ', '.'); 
        listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');     
      }

    } else if(data.clearancePrice.length !== 0) {
      //CHECK TO IF ANY CLEARANCE PRICES ARE RETURNED
      clearTag = true;
      var nettPriceSaving = data.clearancePrice[0].Price; 
      var savingSpecial = data.price[0].Price - data.clearancePrice[0].Price;

      //IF CLEARANCE PRICE IS BIGGER THAN DISCOUNTED, DISPLAY SPECIAL PRICE
      if (savingSpecial > saving) {
        saving = formatMoney(savingSpecial, 2, 'R ', ' ', '.'); 
        nettPrice = formatMoney(nettPriceSaving, 2, 'R ', ' ', '.');
        listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');
      } else { 
        nettPrice = formatMoney(nettPrice, 2, 'R ', ' ', '.');  
        saving = formatMoney(saving, 2, 'R ', ' ', '.'); 
        listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');     
      }

    } else { 
      nettPrice = formatMoney(nettPrice, 2, 'R ', ' ', '.');  
      saving = formatMoney(saving, 2, 'R ', ' ', '.'); 
      listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');     
    }

    /*===========================================================================================*/
    /*  SPECIAL AND CLEARANCE RIBBON FUNCTIONS                                                              */
    /*===========================================================================================*/
    function displayRibbons() {
      //IF PRODUCT HAS A SALES PRICE, DISPLAY RIBBON
      if(data.salesPrice.length !== 0) {
        $(".grid-link__specRib").css("display","block");                     
      } else {
        $(".grid-link__specRib").css("display","none"); 
      } 

      //IF PRODUCT HAS A CLEARANCE PRICE, DISPLAY RIBBON
      if (data.clearancePrice.length !== 0) {
        $(".grid-link__clearRib").show(); 
      } else {
        $(".grid-link__clearRib").hide(); 
      }              
    }


    /*===========================================================================================*/
    /*   BROKEN PRODUCT IMAGE CHECK                                                           */
    /*===========================================================================================*/
    //IF A PRODUCT HAS A BROKEN IMAGE WE NEED TO REPLACE IT WITH THE CATEGORY IMAGE

    switch(data.price[0].Category) {
      case "ALL":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/ALL.png?13999154437255759986";
        break;
      case "AUT":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/AUT.png?13999154437255759986";
        break;
      case "BC1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/BC1.png?13999154437255759986";
        break;
      case "BOB":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/BOB.png?13999154437255759986";
        break;
      case "CB1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CB1.png?13999154437255759986";
        break;
      case "CO1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CO1.png?13999154437255759986";
        break;
      case "CO2":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CO2.png?13999154437255759986";
        break;
      case "COM":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/COM.png?13999154437255759986";
        break;
      case "CON":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CON.png?13999154437255759986";
        break;
      case "ELT":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/ELT.png?13999154437255759986";
        break;
      case "EMP":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/EMP.png?13999154437255759986";
        break;
      case "ESP":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/ESP.png?13999154437255759986";
        break;
      case "DAT":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/DAT.png?13999154437255759986";
        break;
      case "DPM":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/DPM.png?13999154437255759986";
        break;  
      case "EES":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/EES.png?13999154437255759986";
        break; 
      case "ELC":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/ELC.png?13999154437255759986";
        break;
      case "FAN":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/FAN.png?13999154437255759986";
        break;
      case "FLP":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/FLP.png?13999154437255759986";
        break;
      case "GEN":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/GEN.png?13999154437255759986";
        break;
      case "GEW":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/GEW.png?13999154437255759986";
        break;
      case "GEWCB":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/GEWCB.png?13999154437255759986";
        break;
      case "GEWILT":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/GEWILT.png?13999154437255759986";
        break;
      case "H":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/H.png?13999154437255759986";
        break;
      case "HIG":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/HIG.png?13999154437255759986";
        break;
      case "L":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/L.png?13999154437255759986";
        break;
      case "LEG":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/LEG.png?13999154437255759986";
        break;
      case "LIT":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/LIT.png?13999154437255759986";
        break;
      case "M1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CO1.png?13999154437255759986";
        break;
      case "MET":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/MET.png?13999154437255759986";
        break;
      case "OR1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/OR1.png?13999154437255759986";
        break;
      case "P1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/P1.png?13999154437255759986";
        break;
      case "P3":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/P3.png?13999154437255759986";
        break;
      case "P4":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/P4.png?13999154437255759986";
        break;
      case "PM":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/PM.png?13999154437255759986";
        break;
      case "PRO":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/PRO.png?13999154437255759986";
        break;
      case "Q":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/Q.png?13999154437255759986";
        break;
      case "R":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/R.png?13999154437255759986";
        break;  
      case "RE1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/RE1.png?13999154437255759986";
        break;
      case "RHE":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/RHE.png?13999154437255759986";
        break;
      case "RHS":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/RHS.png?13999154437255759986";
        break; 
      case "SCA":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SCA.png?13999154437255759986";
        break;
      case "SEC":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SEC.png?13999154437255759986";
        break;
      case "SM1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SM1.png?13999154437255759986";
        break;
      case "SM2":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SM2.png?13999154437255759986";
        break;
      case "SOL":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SOL.png?13999154437255759986";
        break;
      case "SOL2":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SOL2.png?13999154437255759986";
        break;
      case "T":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/T.png?13999154437255759986";
        break;
      case "T1":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/T1.png?13999154437255759986";
        break;
      case "T2":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/T2.png?13999154437255759986";
        break;
      case "TC":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/TC.png?13999154437255759986";
        break;
      case "TEC":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/TEC.png?13999154437255759986";
        break;
      case "TS":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/TS.png?13999154437255759986";
        break;
      case "U":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/U.png?13999154437255759986";
        break;
      case "U2":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/U2.png?13999154437255759986";
        break;
      case "WIR":
        var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/WIR.png?13999154437255759986";
        break;
    }

    //BUILD NEW OBJECT FOR MUSTACHE
    var NewData = { 
      title: data.price[0].ProductId,
      discription: data.price[0].Discription,
      price: listPrice,
      imageLink : PicLink,
      shopifyProdID : data.price[0].ShopifyProductID,
      shopifyVarID : data.price[0].ShopifyVariantID,
      discount : data.discount[0].Discount + "%",
      stockLM : data.stock["Long Meadow"],
      stockGS : data.stock["Germiston"],
      stockPT : data.stock["Pinetown"],
      stockRH : data.stock["Riverhorse"],
      stockCT : data.stock["Cape Town"],
      stockTotal : data.stock["Long Meadow"] + data.stock["Germiston"] + data.stock["Pinetown"] + data.stock["Riverhorse"] + data.stock["Cape Town"],
      certLink : CertLink,
      specLink : SpecLink,
      savePrice : saving,
      netPrice : nettPrice,
      unitType : unitType,
      catPage : catPage,
      category : category,
      categoryImage : CatImage,
      brand : brand,
      //THIS NEEDS TO CHANGE
      productLink : convertURLslash(removeURLspaces(data.price[0].Discription)),
    }
    $('#loading-image').hide();
    var html = Mustache.to_html(template, NewData);
    $("#product_container").append(html);
    addToFAV();
    displayRibbons();

    //CERT HAS NO LINK, SHOW POPUP
    $("#linkTechSpec").on("click", function(){
      if($(this).hasClass('noCert1')){
        debugger;
        $('.popOverlay').show();
        $('.popText').show();
        $('#certSpec').hide();
        var sku = $('.product-info-code').text();
        $('#IndiProdID').attr('value',sku);
      }
    });
    //CERT HAS NO LINK, SHOW POPUP
    $('#linkProdCert').on('click', function(){
      if($(this).hasClass('noCert2')){
        $('.popOverlay').show();
        $('.popText').show();
        $('#techSpec').hide();
        var sku = $('.product-info-code').text();
        $('#IndiProdID').attr('value',sku);
      }
    });

    //MAKE ADJUSTMENTS TO CERT THAT DONT HAVE LINKS
    var emptyHREF = $(".BlueBlocks").find('#linkTechSpec').attr('href');
    if(emptyHREF === "") {
      $('#product_container').find('#linkTechSpec').removeAttr('target');
      $('#product_container').find('#linkTechSpec').removeAttr('href');
      $('#product_container').find('#linkTechSpec').addClass('noCert1');
    }
    var emptyHREF2 = $(".BlueBlocks").find('#linkProdCert').attr('href');
    if(emptyHREF2 === "") {
      $('#product_container').find('#linkProdCert').removeAttr('href');
      $('#product_container').find('#linkProdCert').removeAttr('target');
      $('#product_container').find('#linkProdCert').addClass('noCert2');
    }
  }).fail(function(err){
    console.log(err);
  });
  var template = $('#productTemplate').html();
  

});